module.exports = __webpack_public_path__ + "images/default_avatars/noon-7f0c0e7c169fb3be414028f8e6bfcf9f.jpg";